import { calculateTotal } from '@calculations/price/utilities/total';
import { SnapRoundingOptionsCustom } from '@calculations/round';
import { PriceStrategyConfigWithRelations } from '@snap-types/models/price-strategy-config';
import { Decimal } from '@snap-types/types/decimal';
import { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

import {
  getQuoteLineOrThrow,
  getQuotePriceOrThrow,
} from '../../utilities/action-guards';
import { OnUnitCostChangeInput } from '../types';
import { applyQuotePriceRecalcResult } from '../utilities/apply-quote-price-recalc-result';
import { buildStrategyCalculations } from '../utilities/build-strategy-calculations';

export function onPartUnitCostChange(
  state: WritableQuoteBuilderStateType,
  params: {
    quoteLineUuid: string;
    quotePriceUuid: string;
    unitCost: Decimal;
    priceStrategyConfigs: PriceStrategyConfigWithRelations[];
  },
) {
  const quoteLine = getQuoteLineOrThrow(state, params.quoteLineUuid);
  const quotePrice = getQuotePriceOrThrow(
    state,
    params.quoteLineUuid,
    params.quotePriceUuid,
  );
  const { priceStrategy } = quotePrice;

  const inputs = {
    state,
    quoteLine,
    quotePrice,
    unitCost: params.unitCost,
    priceStrategyConfigs: params.priceStrategyConfigs,
  } satisfies OnUnitCostChangeInput;

  const calculation =
    buildStrategyCalculations('onUnitCostChange')[priceStrategy];

  if (!calculation) {
    console.error(
      'No unit price calculation function found for price strategy',
      priceStrategy,
    );
    return;
  }

  const result = calculation(inputs);

  if (result.status === 'failure') {
    // @TODO(NT): Our store should be integrated with toast notifications
    console.error('Failed to calculate price', result.reason);
    return;
  }

  applyQuotePriceRecalcResult(state, {
    quoteLineUuid: params.quoteLineUuid,
    quotePriceUuid: params.quotePriceUuid,
    quotePrice,
    patch: {
      unitCost: params.unitCost,
      userUnitCost: params.unitCost,
    },
  });

  if (result.status === 'success') {
    const unitPrice = result.unitPrice;

    applyQuotePriceRecalcResult(state, {
      quoteLineUuid: params.quoteLineUuid,
      quotePriceUuid: params.quotePriceUuid,
      quotePrice,
      patch: {
        unitPrice,
        totalPrice: calculateTotal(
          unitPrice,
          quotePrice.quantity,
          SnapRoundingOptionsCustom(state),
        ),
      },
      rawFieldsToClear: ['unitPrice'],
    });
  }
}
